import { EntityType } from './entity-type';
import { BaseModel } from './base-model';

export class BaseEntity extends BaseModel {
  entityType?: EntityType;
  createdBy?: string;
  createdDate?: Date;
  lastUpdatedBy?: string;
  lastUpdateDate?: Date;
  permissionType?: 'CONTROL' | 'EDIT';
  accessLevel?: any;
  additionalPermissions?: any;
}
